// Phase F — Compact firm badge used in module tables
// Resolves a firm_id to its display name (or "Pool" if empty) via
// the FirmContext so we don't refetch /api/firms per row.

import { useFirms } from "@/contexts/FirmContext";
import { Building2 } from "lucide-react";

export default function FirmBadge({ firmId, size = "sm", testid }) {
  const { firms } = useFirms();
  const isPool = !firmId;
  const firm = isPool ? null : firms.find((f) => f.id === firmId);
  const label = isPool ? "Pool" : (firm?.name || "Unbekannt");
  const isUnknown = !isPool && !firm;

  const tone = isPool
    ? "bg-zinc-800/60 text-zinc-400 border-zinc-700"
    : isUnknown
      ? "bg-rose-500/10 text-rose-300 border-rose-500/30"
      : "bg-blue-500/10 text-blue-300 border-blue-500/30";

  const sz = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";

  return (
    <span
      data-testid={testid || (firmId ? `firm-badge-${firmId}` : "firm-badge-pool")}
      title={isPool ? "Sichtbar in allen Firmen (Pool)" : firm?.name}
      className={`inline-flex items-center gap-1 rounded border font-medium ${tone} ${sz}`}
    >
      <Building2 className="w-3 h-3 opacity-70" />
      {label}
    </span>
  );
}
